import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { PurposeService } from 'src/app/shared/service/disbursment/purpose.service';
import { CreatePurposeComponent } from '../../../dis-repository/pages/create-purpose/create-purpose.component';
import { MaPurpose } from '../../../dis-repository/pages/create-purpose/purpose.model';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ToastrService } from 'ngx-toastr';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.scss']
})
export class PurposeComponent {
 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;

  searchTerm: string = '';
  displayedColumns: string[] = ['Sl.No', 'name', 'Action'];
  dataSource = new MatTableDataSource<MaPurpose>();

  currentPage = 1;
  pageSize = 50;
  totalCount = 0;
  allDataLoaded = false;
  private searchSubject = new Subject<string>();

  constructor(
    private dialog: MatDialog,
    private purposeService: PurposeService,
    private snackBar: ToastrService,
        private requestFormService: RequestFormService,
  ) { }

  ngOnInit() {
    this.getMaPurposeDataFromDb(true);

    // Setup debounce for search
    this.searchSubject
      .pipe(
        debounceTime(1000)
      )
      .subscribe(() => {
        this.onSearch();
      });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  onSearch(): void {
    this.getMaPurposeDataFromDb(true);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.getMaPurposeDataFromDb(true);
  }

  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (
        scrollPosition >= scrollHeight - 10 &&
        !this.loader.loading$ &&
        !this.allDataLoaded
      ) {
        this.getMaPurposeDataFromDb();
      }
    }
  }

  getMaPurposeDataFromDb(reset = false): void {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
    };

    this.loader.show();

    this.purposeService.purposeDataFromDb(body).subscribe({
      next: (response: { data: MaPurpose[]; total_count: number }) => {
        const newData = response.data;
        this.totalCount = response.total_count;

        this.dataSource.data = [...this.dataSource.data, ...newData];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loader.hide();
      },
      error: () => {
        this.snackBar.error("Something went wrong. Please try again later.");
        this.loader.hide();
      }
    });
  }

  openAddPurposeDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreatePurposeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaPurposeDataFromDb(true);
      }
    });
  }

  openEditPurposeDialog(rowData: MaPurpose): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.data = { rowData };
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreatePurposeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getMaPurposeDataFromDb(true);
      }
    });
  }

    isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
